import { Organization } from "../models/organizations.entity";
import { SubscriptionPlanMetadata, SubscriptionPlan } from "../models/subscription-plan.metadata";

export function flattenOrganizationTrees(organizations: Organization[]): Organization[] {
  return organizations.flatMap(organization => [ organization, ...(organization?.children?.length ? flattenOrganizationTrees(organization?.children) : []) ]);
}

export function getOrganizationPlanMetadataByPlanTagname(name: string): SubscriptionPlan  {
  return SubscriptionPlanMetadata[name];
}